<template>
    <div id="pass">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="22" :sm="10" :md="8" class="titulo">
                Recuperar Contraseña
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="24" :sm="13" :md="10" class="cuerpo">


                <!-- Alertas - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
                <v-alert type="success" color="green" v-if="exito" style="margin-bottom:30px" :value="true">
                    En breve recibirá un correo electrónico a <span style="font-size:large">{{ f.mail }}</span> con sus datos de acceso al Panel.<br>¡Muchas Gracias!
                </v-alert>
                <v-alert type="error" color="red" v-if="error" style="margin-bottom:30px" :value="true">
                    <strong>Usuario no registrado.</strong><br>Puede registrarse desde <router-link :to="'registro'"><strong>aquí</strong></router-link>.
                </v-alert>
                <v-alert v-if="tiempo" type="error" color="orange" style="margin-bottom:30px" :value="true">
                    Su Contraseña ya ha sido cambiada en un plazo menor a 6 hs. Intente mas tarde nuevamente.
                </v-alert>


                <el-form ref="f" :model="f" :rules="rules">
                    
                    
                    <!-- Formulario -->
                    <el-form-item prop="dni">
                        <el-input type="text" ref="Username" v-model="f.dni" placeholder="Ingrese su DNI sin puntos" @paste.prevent @keypress.native="control($event)" maxlength="8">
                            <template slot="prepend"><img src="https://docentes.educaciondigitaltuc.gob.ar/assets/face.svg"/></template>
                        </el-input>
                    </el-form-item>

                    
                    <!-- Re-Captcha -->
                    <el-row>
                        <div style="float:right">
                            <vue-recaptcha 
                                ref="recaptcha"
                                size="normal"
                                sitekey="6LcFEH4aAAAAAIbFqQzBOaOPYHU8s25Xk9K9F-cx"
                                @verify="onVerify"
                                @expired="onExpired"
                                :loadRecaptchaScript="true"
                            ></vue-recaptcha>
                        </div>
                        <div style="float:right; text-align:right; padding:10px; margin-bottom:20px">
                            <button class="BtnA" style="font-size:small" @click="resetRecaptcha">Reset ReCAPTCHA </button>
                        </div>
                    </el-row>
                    
                    
                    <!-- Alertas -->
                    <el-row>
                        <div style="background:red; padding:10px; margin-top:30px; font-size:16px">
                            Si <strong>no recibe el mail</strong> en la bandeja de entrada, verifique en <strong>"Correo no Deseado"</strong> o <strong>"Spam"</strong>.<br><br>
                            <small>Le recomendamos marcar el al correo como "Seguro" para recibir los próximos correos en la bandeja de entrada.</small>
                        </div>
                        <div style="background:orange; padding:10px; margin-top:30px; font-size:14px">
                            Si tiene inconvenientes en recuperar los datos de acceso puede contactarse enviando un correo electrónico al Centro de Atención Educativa: <strong>centrodeatencion@educaciontuc.gov.ar</strong>
                        </div>
                    </el-row>


                    <!-- Botones -->
                    <el-form-item style="margin-top:30px !important">
                        <v-col class="col-12">
                            <v-btn 
                                raised 
                                block
                                color="blue" 
                                :loading="cargando" 
                                :disabled="!verificado"
                                @click="submitForm('f')"
                                style="color:#fff"
                            >
                                Recuperar
                            </v-btn>
                        </v-col>
                    </el-form-item>
                    <el-form-item style="margin-top:20px !important">
                        <router-link class="el-col el-col-24 el-button" :to="'/'"                                       >Volver     </router-link>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios        from 'axios';
    import VueRecaptcha from 'vue-recaptcha';


    export default
    {   data()
        {   sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
        
            return {
                cargando:   false,
                exito:      false,
                error:      false,
                tiempo:     false,
                verificado: false,
                f: {
                    dni:   '',
                },
                rules: {
                    dni: [
                        { required: true, message: 'Por favor, ingrese su DNI', trigger: 'blur' },
                        { min: 7, max: 8, message: 'Documento Inválido', trigger: 'blur' }
                    ]
                }
            }
        },



        components: {
            'vue-recaptcha': VueRecaptcha
        },        
        

        
        methods: {
            onVerify: function (response) 
            {   this.verificado = true;
            },
            onExpired: function () 
            {   this.$refs.recaptcha.reset();
            },
            resetRecaptcha () 
            {   this.$refs.recaptcha.reset();
            },
            control(e)
            {   if(e.keyCode === 13) { this.submitForm('f'); }                          // Envia apretando el Enter
                if( (e.which>31 & e.which<48) || e.which>57) { e.preventDefault(); }    // Campo numerico
            },
            submitForm(formName)
            {   this.cargando                       = true;
                this.exito                          = false;
                this.error                          = false;
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {   var params  = 'dni=' + this.f.dni;
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        
                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/pss_rec.php', params, {headers: headers})
                            .then(response => {
                                const datos         = response.data;
                                if(datos!='Tiempo')
                                {   this.f.mail     = datos['mail'];
                                    this.exito      = true;
                                    this.error      = false;
                                    this.cargando   = false;
                                    this.verificado = false;
                                    
                                }
                                else
                                {   this.tiempo     = true;  
                                }
                            })
                            .catch(e => {
                                this.error          = true;
                            })
                    }
                })
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Username.focus);
        }
    };
</script>
